import React, { Component } from 'react';
import { Link } from 'gatsby';

import promotion from '../../../../promotion_config';
import Welcome from './header/welcome.js';
import PrimaryNav from './header/primary_nav.js';

import lottery_logo from './header/logo.png';
import promo_logo from './header/promo.png';

import './style.scss';
import ContentLoading from '../../widgets/content_loading.js';

class Header extends Component {
    constructor(props) {
        super(props);
        this.actions = props.actions;
    }

    render() {
        return (
            <header>
                <div className="row promo-top justify-content-between">
                    <div className="col align-self-center">
                        <a
                            href={promotion.lotteryUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={lottery_logo}
                                alt={promotion.lotteryName}
                                className="img-fluid d-block mx-auto"
                            />
                        </a>
                    </div>
                    <div className="col align-self-center">
                        <Link className="promo-logo" to="/">
                            <img
                                src={promo_logo}
                                alt={promotion.title}
                                className="img-fluid d-block mx-auto"
                            />
                        </Link>
                    </div>
                    <div className="col align-self-center">
                        <ContentLoading
                            hasIcon={true}
                            loadedAction="getPlayerData"
                        >
                            <Welcome
                                user={this.props.user}
                                actions={this.actions}
                            />
                            <button
                                className="navbar-toggler"
                                type="button"
                                data-toggle="collapse"
                                data-target="#primary-nav"
                                aria-controls="primary-nav"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                        </ContentLoading>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <PrimaryNav
                            user={this.props.user}
                            actions={this.actions}
                            menuLinks={this.props.mainMenu}
                        />
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;
